import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { MessageDescriptorPropType } from '../../../../../prop-types/intl';

const InputWithErrorTooltip = ({
  id = '',
  type = '',
  maxLength,
  labelDescriptor,
  disabled = false,
  value = '',
  onChange = noop,
  onFocus = noop,
  hasError = false,
  errorDescriptor,
  disabledTooltipMessage,
}) => {
  const hasErrorToDisplay = hasError && !!errorDescriptor;
  const isDisabledAndHasTooltipMessage = disabled && !!disabledTooltipMessage;
  const shouldHideTooltip = !hasErrorToDisplay && !isDisabledAndHasTooltipMessage;
  const TooltipMessage = () => {
    if (hasErrorToDisplay) {
      return <FormattedMessage {...errorDescriptor} />;
    }
    if (disabled && !!disabledTooltipMessage) {
      return <FormattedMessage {...disabledTooltipMessage} />;
    }
    return null;
  };
  return (
    <>
      {labelDescriptor ? <FormattedMessage {...labelDescriptor} /> : null}
      <Tooltip shouldHideTooltip={shouldHideTooltip}>
        <div>
          <Input
            data-testid={`info-${id}`}
            disabled={disabled}
            hasError={hasError}
            maxLength={maxLength}
            onChange={(v) => onChange(id, v)}
            onFocus={onFocus}
            type={type}
            value={value}
          />
        </div>
        <TooltipContent>
          <TooltipMessage />
        </TooltipContent>
      </Tooltip>
    </>
  );
};

InputWithErrorTooltip.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  labelDescriptor: MessageDescriptorPropType,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  hasError: PropTypes.bool,
  errorDescriptor: MessageDescriptorPropType,
  disabledTooltipMessage: MessageDescriptorPropType,
};

export default InputWithErrorTooltip;
